import { Rating } from '@mui/material';
import Flex from 'legacyfrontend/components/Flex';
import IconButton from 'legacyfrontend/components/packages/components/IconButton';
import capitalizeWords from 'legacyfrontend/utils/capitalize-words';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';

const HotelInfoCard = ({ hotel, totalNightText, provider_id, hotelInformation }) => {
  const { t } = useTranslation('layout');
  const [displayDescription, setDisplayDescription] = useState(false);

  const handleDisplayDescriptionToggle = (value) => {
    setDisplayDescription(value !== undefined ? !!value : (state) => !state);
  };
  return (
    <Flex className='package-details__dynamic-content__wrapper__hotel-list__records__card'>
      <Flex
        className='package-details__dynamic-content__wrapper__hotel-list__records__card__info'
        vertical
      >
        <Flex className='package-details__dynamic-content__wrapper__hotel-list__records__card__info__wrapper'>
          <Flex
            className='package-details__dynamic-content__wrapper__hotel-list__records__card__info__title'
            vertical
          >
            <h5>{capitalizeWords(hotel.hotel.name)}</h5>
            <Rating
              className='package-details__dynamic-content__wrapper__hotel-list__records__card__info__title__rating'
              readOnly
              size='small'
              value={hotel.hotel.category}
            />
          </Flex>
        </Flex>
        <Flex className='package-details__dynamic-content__wrapper__hotel-list__records__card__info__details'>
          <strong className='package-details__dynamic-content__wrapper__hotel-list__records__card__info__details__first-line'>
            <span>{totalNightText}</span>
            <span>{capitalizeWords(hotel.regime)}</span>
            <span>{capitalizeWords(hotel.roomType)}</span>
          </strong>
          {provider_id === 3 && displayDescription == false ? (
            <FaPlusCircle
              className='package-simple-icon-button active'
              onClick={() => {
                handleDisplayDescriptionToggle();
              }}
            />
          ) : provider_id === 3 && displayDescription == true ? (
            <FaMinusCircle
              className='package-simple-icon-button'
              onClick={() => {
                handleDisplayDescriptionToggle();
              }}
            />
          ) : null}
          {provider_id === 3 && (
            <>
              {!displayDescription ? (
                <FaPlusCircle
                  className='package-simple-icon-button active'
                  onClick={() => {
                    handleDisplayDescriptionToggle();
                  }}
                />
              ) : (
                <FaMinusCircle
                  className='package-simple-icon-button'
                  onClick={() => {
                    handleDisplayDescriptionToggle();
                  }}
                />
              )}
            </>
          )}
        </Flex>
        {displayDescription && provider_id === 3 && (
          <Flex className='package-details__dynamic-content__wrapper__hotel-list__records__card__info__description__content'>
            {hotelInformation?.[0]?.hotel?.description}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default HotelInfoCard;
